export default __webpack_public_path__ + "static/media/123.6de5d765.webp";